import { useEffect, useState } from "react";
import { RequestHelper } from "../../../utils/requestHelper";
import {
  AllCommunityModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  ValidationModule,
} from "ag-grid-community";
import {
  CellSelectionModule,
  ClipboardModule,
  RowGroupingModule,
  RowGroupingPanelModule,
} from "ag-grid-enterprise";
import { ExcelExportModule } from "ag-grid-enterprise";
import { ColumnBuilder } from "./ColumnBuilder";
import { _ROUTES } from "../../../utils/_routes_constants";
import { getDataGeneric } from "../../../repository/DataGeneric";
import CustomGroupHeader from "./CustomGroupHeader";
import { _COLORS } from "../../../utils/constants";
import { useSalesOnCellValueChanged } from "./useSaveSalesOnCellChanged";
import { DataTable } from "../../ui/DataTable";
import { SALES_FILAIRE_TOTAL_VALUE, SALES_FILAIRE_TOTAL_VOLUME } from "../../../utils/savedDataConstant/inputSalesFilaireSaveConstants";

ModuleRegistry.registerModules([
  AllCommunityModule,
  ExcelExportModule,
  ClientSideRowModelModule,
  ValidationModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  ClipboardModule,
]);

/**
 *
 * @param {string}params.site
 * @param {string} params.fiscalYear
 * @param {string} params.version
 * */
export const AgGridVolumeFilaire = ({ params, gridRef }) => {
  const requestHelper = new RequestHelper();
  const [rowsData, setRowsData] = useState([]);
  const [columns] = useState(ColumnBuilder());
  const [pendingRefresh, setPendingRefresh] = useState(false);

  useEffect(() => {
    if (!params?.site) {
      return;
    }
    const queryParams = {
      site: params.site,
    };

    if (params.fiscalYear) queryParams.fiscalYear = params.fiscalYear;
    if (params.version) queryParams.version = params.version;

    getDataGeneric(
      requestHelper,
      queryParams,
      (data) => {
        setRowsData(data);
      },
      _ROUTES.CUSTOM_IPT_SF,
      "Unable to retrieve sale filaires rows",
    );
  }, [params.site, pendingRefresh]);

  const onCellValueChanged = useSalesOnCellValueChanged(
    params,
    setPendingRefresh,
  );

  const defaultColDef = {
    cellClassRules: {
      "total-header-col": (params) => {
        return params.colDef.field === "total";
      },
      "total-row": (params) =>
        params.node && params.node.aggData && params.node.footer,
    },
  };

  const excelStyles = [
    {
      id: "month-header",
      interior: {
        color: _COLORS.headerAgGrid,
        pattern: "Solid",
      },
    },
    {
      id: "total-header-col",
      interior: {
        color: _COLORS.totalAgGrid,
        pattern: "Solid",
        font: {
          bold: true,
        },
      },
    },
    {
      id: "total-row",
      class: "total-row",
      interior: {
        color: _COLORS.totalLabourRow,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
  ];

  return (
    <>
      <DataTable
        gridRef={gridRef}
        rows={rowsData}
        columns={columns}
        excelStyles={excelStyles}
        onCellValueChanged={onCellValueChanged}
        fullHeight={true}
        rowHeight={25}
        agGridProps={{
          cellSelection: true,
          copyHeadersToClipboard: false,
          defaultColDef: defaultColDef,
          groupDisplayType: "groupRows",
          groupDefaultExpanded: -1,
          suppressAggFuncInHeader: true,
          groupTotalRow: (p) =>
            ["VOLUME", "TURNOVER RS"].includes(p?.node?.key)
              ? "bottom"
              : undefined,
          getRowClass: (params) => {
            if (params.node && params.node.aggData && params.node.footer) {
              return "total-row";
            }
            return null;
          },
          getRowStyle: (params) => {
            if (params.node && params.node.aggData && params.node.footer) {
              const rowName =
                params.node.key === "VOLUME"
                  ? SALES_FILAIRE_TOTAL_VOLUME
                  : SALES_FILAIRE_TOTAL_VALUE;

              params.node.aggData.rowName = rowName;
            }
          },
          groupRowRenderer: (node) => (
            <CustomGroupHeader
              node={node}
              style={{ color: _COLORS.groupTitleColor }}
            />
          ),
        }}
      />
    </>
  );
};
